import { Flex, useToast } from '@chakra-ui/react'
import { ModalBody } from './styles'
import { useState } from 'react'
import { appApi } from '../../../../../../services/appApi'
import { ModalBase } from '../../../../../../components/ModalBase'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { PropInvalida } from '../../../../../../Utils/Helper'
import { FormInpuFile } from './components/FormInputFile'

interface iModal {
  isOpen: boolean
  onRequestClose: () => void
  pesquisaId: string
  onPost: () => void
}

export const ModalCadastroEmMassa: React.FC<iModal> = ({ onRequestClose, onPost, pesquisaId, isOpen }) => {
  if (!isOpen) return null

  const toast = useToast()

  const [Arquivo, setArquivo] = useState<FormData>()
  const [Nome, setNome] = useState()
  const [IsLoading, setIsLoading] = useState(false)

  const AtualizarArquivo = (arquivo: any): void => {
    if (PropInvalida(arquivo)) {
      setNome(undefined)
      setArquivo(undefined)
    } else {
      const formdata = new FormData()
      formdata.append('arquivo', arquivo.target.files[0])
      setArquivo(formdata)
      setNome(arquivo.target.files[0].name)
      toast({
        title: 'Arquivo selecionado com sucesso!',
        status: 'success',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
    }
  }

  function CriarPorPlanilha(): void {
    setIsLoading(true)
    appApi.post(`PesquisaInternaConvite/uploadcsv?pesquisaId=${pesquisaId}`, Arquivo)
      .then((res) => {
        toast({
          title: 'Convites cadastrados com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        onPost()
      })
      .catch((er) => {
        toast({
          title: 'Erro',
          status: 'error',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  function GerarCsvDeExemplo(): void {
    const blob = new Blob(['Nome (Obrigatorio);Email (Obrigatorio);'], { type: 'text/csv;charset=utf-8' })

    const linkDownload = document.createElement('a')
    linkDownload.href = URL.createObjectURL(blob)
    linkDownload.download = 'Exemplo.csv'

    document.body.appendChild(linkDownload)
    linkDownload.click()

    document.body.removeChild(linkDownload)
  }

  return (
    <ModalBase
      Titulo='Cadastrar convites em massa'
      isOpen
      onClose={onRequestClose}
      Width='55rem'
    >
      <ModalBody>
        <span style={{ fontSize: '.875rem' }}><strong>Instruções para gerar o arquivo no excel: </strong>
          Baixe o arquivo de exemplo e preencha com os dados abaixo da linha de título.
          Após isso, clique em "Salvar como..." e selecione o formato
          <b> CSV UTF-8 (Delimitado por vírgulas).</b>
          As colunas que estão marcadas com “*” são campos obrigatórios.
          Por favor, realize o preenchimento completo para correto envio.
          <small> Obrigatório a inserção do endereço de email</small>
        </span>

        <Flex mt={'1rem'} w={'100%'}>
          <FormInpuFile onUpdate={AtualizarArquivo} nome={Nome} />
        </Flex>
      </ModalBody>
      <Flex justifyContent={'end'} padding='1rem' gap={'.5rem'}>
        <ButtonCmp
          onClick={GerarCsvDeExemplo}
          VarColor='Rosa'
        >Baixar exemplo para preenchimento</ButtonCmp>

        <ButtonCmp
          isDisabled={PropInvalida(Arquivo)}
          onClick={CriarPorPlanilha}
          VarColor='Green2'
          isLoading={IsLoading}
        >Enviar arquivo</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
